<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-40">
				<md-field>
					<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
					<md-input v-model="search.client" type="text" @keyup.enter="searchPayment()"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-50 md-size-20">
				<md-button class="md-raised md-primary" @click="searchPayment()" style="width: 100%">ស្វែងរក</md-button>
			</div>
			<div class="md-layout-item md-small-size-50 md-size-40 text-right" style="display: flex; justify-content: right; align-items: center;">
				ទឹកប្រាក់បានទូទាត់ ៖ {{config.moneylify(credit_balance_usd)}} + {{config.moneylify(credit_balance_khr, "khr")}}
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<loading v-if="!loaded"/>
				<h4 class="text-center" v-if="clientList.length == 0 && loaded == true">មិនមានទិន្នន័យ</h4>
			</div>
			
		</div>

		<md-card v-for="(client, index) in clientList">
			<md-card-content>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h4 class="title">{{index+1}}. <b>{{client.client_name}}</b> ({{client.client_note}})</h4>
					</div>
					
					<div class="md-layout-item md-small-size-100 md-size-100">
						<table class="table-payment">
							<tr>
								<td>លេខកូដ</td>
								<td>ប្រភេទ និងទីតាំង</td>
								<td>អ្នកទទួល និងចំណាំ</td>
								<td>តម្លៃឥវ៉ាន់</td>
								<td>ថ្លៃដឹកជញ្ជូន</td>
								<td>ស្ថានភាព</td>
							</tr>

							<tr v-for="(pkg, index) in client.packageList">
								<td>{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
								</td>
								<td><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</td>
								<td>{{ pkg.receiver_phone }}<br><span v-if="pkg.status != 'dlv'">{{pkg.note}}</span></td>
								<td>
									<span v-if="pkg.status == 'dlv'">
										<b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
										<br>
										<span v-if="pkg.price == 0">(ទូទាត់រួច)</span>
										<span v-else>(មិនទាន់ទូទាត់)</span>
									</span>
									<span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
										}})</span>
								</td>
								<td>
									<span v-if="pkg.status == 'dlv'">
										<b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
										<br>
										<span> ({{config.getStatus(pkg.fee_responsible)}})</span>
									</span>
									<span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
								</td>
								<td>
									<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
									<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
									<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
									<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
									<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
								</td>
							</tr>
							<tr>
								<td></td>
								<td></td>
								<td style="text-align: right;"><b>សរុប:</b></td>
								<td><b>{{config.moneylify(client.total_usd, 'usd')}} +
										{{config.moneylify(client.total_khr, 'khr')}}</b></td>
								<td><b>{{config.moneylify(client.total_fee_usd, 'usd')}} +
										{{config.moneylify(client.total_fee_khr, 'khr')}}</b></td>
								<td></td>
							</tr>
						</table>
					</div>
					<div class="md-layout-item md-size-35 text-right client-center">
						<!-- <img :src="config.getProfileUrl(client.client_bank_usd)" class="bank-image" />
						<img :src="config.getProfileUrl(client.client_bank_khr)" class="bank-image"  /> -->
					</div>
					<div class="md-layout-item md-size-35 text-right client-center">
						<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអតិថិជនសរុប : {{config.moneylify(client.total_usd -
								client.total_fee_usd,
								'usd')}} +
								{{config.moneylify(client.total_khr - client.total_fee_khr, 'khr')}}</span></b>
					</div>
					<div class="md-layout-item md-size-15 text-right client-center">
						<!-- <a :href="'#/print_payment/' + client.client_hash_id" target="_blank">
							<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
						</a> -->
					</div>
					<div class="md-layout-item md-size-15 text-right client-center">
						<md-button class="md-raised md-primary" style="width:100%" @click="selectPay(client)">ចាប់ផ្តើមទូទាត់</md-button>
					</div>
				</div>
			</md-card-content>
		</md-card>

		<transition name="fade" mode="out-in">
			<div class="md-overlay md-fixed md-dialog-overlay" v-show="action.show" @click="close_dialog()"></div>
		</transition>
		<div class="md-dialog md-theme-default dialog-container" v-if="action.show">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-100 text-center">
					<h4 class="title"><b>{{action.client.client_name}}</b> ({{action.client.client_note}})</h4>
					<md-button class="md-raised md-danger" @click="close_dialog()">បោះបង់</md-button>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-head>លេខកូដ</md-table-head>
							<md-table-head>ប្រភេទ និងទីតាំង</md-table-head>
							<md-table-head>អ្នកទទួល និងចំណាំ</md-table-head>
							<md-table-head>តម្លៃឥវ៉ាន់</md-table-head>
							<md-table-head>ថ្លៃដឹកជញ្ជូន</md-table-head>
							<md-table-head>ស្ថានភាព</md-table-head>
						</md-table-row>

						<md-table-row v-for="(pkg, index) in action.client.packageList">
							<md-table-cell>{{ index + 1 }}, <b>{{ pkg.tracking }}</b><br>{{config.datelify(pkg.created_date)}}
							</md-table-cell>
							<md-table-cell><b>{{ pkg.location }}</b><br>{{ pkg.package_type }}</md-table-cell>
							<md-table-cell>{{ pkg.receiver_phone }}<br><span v-if="pkg.status != 'dlv'">{{pkg.note}}</span></md-table-cell>
							<md-table-cell>
								<span v-if="pkg.status == 'dlv'">
									<b>{{ config.moneylify(pkg.price, pkg.price_currency) }}</b>
									<br>
									<span v-if="pkg.price == 0">(ទូទាត់រួច)</span>
									<span v-else>(មិនទាន់ទូទាត់)</span>
								</span>
								<span v-else><b>-----</b><br>({{ config.moneylify(pkg.price, pkg.price_currency)
									}})</span>
							</md-table-cell>
							<md-table-cell>
								<span v-if="pkg.status == 'dlv'">
									<b>{{ config.moneylify(pkg.fee, pkg.fee_currency) }} </b>
									<br>
									<span> ({{config.getStatus(pkg.fee_responsible)}})</span>
								</span>
								<span v-else><b>-----</b><br>({{ config.moneylify(pkg.fee, pkg.fee_currency) }})</span>
							</md-table-cell>
							<md-table-cell>
								<span class="error" v-if="pkg.status == 'ndv'">{{ config.getStatus(pkg.status) }}</span>
								<span class="late" v-if="pkg.status == 'wdv'">{{ config.getStatus(pkg.status) }}</span>
								<span class="neutral" v-if="pkg.status == 'dvr'">{{ config.getStatus(pkg.status) }}</span>
								<span class="green" v-if="pkg.status == 'dlv'">{{ config.getStatus(pkg.status) }}</span>
								<span class="return" v-if="pkg.status == 'rtn'">{{ config.getStatus(pkg.status) }}</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell></md-table-cell>
							<md-table-cell></md-table-cell>
							<md-table-cell style="text-align: right;"><b>សរុប:</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(action.client.total_usd, 'usd')}} +
									{{config.moneylify(action.client.total_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell><b>{{config.moneylify(action.client.total_fee_usd, 'usd')}} +
									{{config.moneylify(action.client.total_fee_khr, 'khr')}}</b></md-table-cell>
							<md-table-cell></md-table-cell>
						</md-table-row>
					</md-table>

				</div>
				<div class="md-layout-item md-size-35 text-right client-center">
					<img :src="config.getProfileUrl(action.client.client_bank_usd)" class="bank-image" />
					<img :src="config.getProfileUrl(action.client.client_bank_khr)" class="bank-image"  style="margin-bottom: 30px;"/>
				</div>
				<div class="md-layout-item md-size-35 text-right client-center">
					<b><span>ប្រាក់ត្រូវទូទាត់ឱ្យអតិថិជនសរុប : {{config.moneylify(action.client.total_usd -
							action.client.total_fee_usd,
							'usd')}} +
							{{config.moneylify(action.client.total_khr - action.client.total_fee_khr, 'khr')}}</span></b>
				</div>
				<div class="md-layout-item md-size-15 text-right client-center">
					<a :href="'#/print_payment/' + action.client.client_hash_id" target="_blank">
						<md-button class="md-raised md-primary" style="width:100%">បោះពុម្ភ</md-button>
					</a>
				</div>
				<div class="md-layout-item md-size-15 text-right client-center">
					<md-button class="md-raised md-primary" style="width:100%" @click="showDialog(action.client)">បញ្ជាក់ទូទាត់</md-button>
				</div>
			</div>
		</div>

		<md-dialog-confirm :md-active.sync="payDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់សម្រាប់អតិថិជននេះមែនទេ ?"
			md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="payClient" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchPayment();
		},
		beforeDestroy() {
			clearInterval(this.action.interval);
		},
		data() {
			return {
				loaded: false,
				payDialogActive: false,
				paySelected: null,
				search: {
					client: "",
					driver: "",
					driver_fee: "",
					driver_pickup_fee: "",
					referral_fee: ""
				},
				action: {
					show: false,
					client: null,
					interval: null
				},
				loadMore: true,
				clientList: [],
				admin_id: "",
				credit_balance_usd: 0,
				credit_balance_khr: 0
			}
		},
		methods: {
			searchPayment() {
				this.$http.post(this.config.api + "/admin/client/get/payment", {
					text: this.search.client
				}).then(data => {
					if (data.body.status == 'success') {
						const now = Date.now();

						this.clientList = data.body.data.filter(item => {

							let add = true;

							let total_usd = item.total_usd - item.total_fee_usd;
							let total_khr = item.total_khr - item.total_fee_khr;
							
							if(total_usd < 0 || total_khr < 0) add = false;

							const lockTime = (new Date(item.payment_lock_date).getTime()) * 1000;
							if(now - lockTime < 30000 && this.admin_id != item.payment_lock_admin_id) add = false;

							return add;
						});

						this.clientList.sort((a, b) => {
							const totalA = (a.total_usd || 0) + ((a.total_khr || 0) / 4000);
    						const totalB = (b.total_usd || 0) + ((b.total_khr || 0) / 4000);
							return totalB - totalA;
						});

						this.loaded = true;
					}
				})

				this.$http.get(this.config.api + "/admin/get_user_data").then(data => {
					this.credit_balance_usd = data.body.data.credit_balance_usd;
					this.credit_balance_khr = data.body.data.credit_balance_khr;
					this.admin_id = data.body.data.admin_id;
				});
			},
			
			payClient() {
				this.$http.post(this.config.api + "/admin/client/pay", {
					client: this.paySelected
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ទូទាត់ប្រាក់ជូនអតិថិជនបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.client = "";
						this.close_dialog();
						this.searchPayment();
					}

				})
			},
			selectPay(client) {
				this.intervalCheck(client);
				this.action.interval = setInterval(this.intervalCheck, 8000, client);
			},
			intervalCheck(client) {
				this.$http.post(this.config.api + "/admin/client/lock_payment", {
					hash_id: client.client_hash_id
				}).then(data => {
					this.$http.post(this.config.api + "/admin/client/get/payment", {
						text: client.client_hash_id
					}).then(data1 => {

						if (data.body.status == 'success' && data1.body.status == 'success' && data1.body.data.length === 1) {
							this.action.client = data1.body.data[0];
							this.action.show = true;
						} else {
							this.close_dialog();
							this.searchPayment();
						}
					})
				})
			},
			showDialog(client) {
				this.paySelected = client;
				this.payDialogActive = true;
			},
			close_dialog() {
				this.action.show = false;
				this.action.client = null;
				clearInterval(this.action.interval);
				this.loaded = false;
				this.clientList = [];
				this.searchPayment();
			},
			onCancel() {
				this.paySelected = null;
				this.payDialogActive = false;
			}
		}
	}
</script>
<style scoped>
	.table-payment {
		width: 100%;
		border-collapse: collapse;
	}

	.table-payment tr td, .table-payment tr th {
		border-bottom: 1px solid #DDD;
		padding: 5px;
	}

	.payment-table {
		width: 100%;

	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}
	.bank-image {
		margin-right: 10%;
		width: 40%;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
	.client-center {
		display: flex;
		justify-content: right;
		align-items: center;
	}
	.dialog-container {
		width: 95%;
		max-width: 95% !important;
		max-height: 95%;
		height: 90%;
		padding: 15px;
		border-radius: 6px;
		overflow-y: scroll;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
</style>



// WEBPACK FOOTER //
// src/pages/AccountantsPayments/View.vue